/**
 * تنسيق التاريخ إلى صيغة YYYY-MM-DD
 * @param {Date} date - التاريخ المطلوب تنسيقه
 * @returns {string} التاريخ المنسق
 */
export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * الحصول على أيام الشهر
 * @param {Date} date - التاريخ
 * @returns {Array} قائمة الأيام
 */
export const getDaysInMonth = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const firstDay = new Date(year, month, 1, 12);
  const lastDay = new Date(year, month + 1, 0, 12);
  const daysInMonth = lastDay.getDate();
  const startingDayOfWeek = firstDay.getDay();

  const days = [];

  const prevMonth = new Date(year, month - 1, 0, 12);
  for (let i = startingDayOfWeek - 1; i >= 0; i--) {
    const day = new Date(year, month - 1, prevMonth.getDate() - i, 12);
    days.push({ date: day, isCurrentMonth: false, isPrevMonth: true });
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const d = new Date(year, month, day, 12);
    days.push({ date: d, isCurrentMonth: true, isPrevMonth: false });
  }

  // Pad out to whole weeks only — a fixed 42-cell grid leaves a dead,
  // entirely-greyed-out sixth row on any month that fits in five.
  const cellCount = Math.ceil(days.length / 7) * 7;
  const remainingDays = cellCount - days.length;
  for (let day = 1; day <= remainingDays; day++) {
    const d = new Date(year, month + 1, day, 12);
    days.push({ date: d, isCurrentMonth: false, isPrevMonth: false });
  }

  return days;
};
